import { render, staticRenderFns } from "./FeedEditor.vue?vue&type=template&id=78cbb9c5&"
import script from "./FeedEditor.vue?vue&type=script&lang=js&"
export * from "./FeedEditor.vue?vue&type=script&lang=js&"
import style0 from "./FeedEditor.vue?vue&type=style&index=0&id=78cbb9c5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports